import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export interface ReportGenerationInProgressDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ReportGenerationInProgressDialog({
  isOpen,
  onOpenChange,
}: ReportGenerationInProgressDialogProps): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    onOpenChange(false);
  };

  const handleGoToReportHub = () => {
    onOpenChange(false);
    navigate('/report-hub');
  };

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className="w-max-4xl"
      hideCloseButton
    >
      <div
        className="flex flex__dir--column flex__ai--center text-align-center"
        style={{ paddingTop: '8px' }}
      >
        <div className="flex flex__ai--center flex__jc--center m-bottom-l">
          <Icon name="info" size={IconSizeClasses.XLarge} className="bg-blue-500" />
        </div>
        <Dialog.Title className="m-bottom-m font-weight-semibold">
          <span style={{ fontSize: '24px' }}>
            {t('auditEvents.export.inProgress.title', 'Report generation in process')}
          </span>
        </Dialog.Title>
        <div
          className="text-gray-600 font-size-m text-align-left"
          style={{ lineHeight: '1.5' }}
        >
          This may take a few moments. You&apos;ll find your ZIP file ready to download in
          the Report Hub once it&apos;s complete.
        </div>
      </div>

      <Dialog.Actions className="m-top-xxl">
        <Button variant="secondary" onClick={handleClose}>
          {t('shared.close', 'Close')}
        </Button>
        <Button variant="primary" onClick={handleGoToReportHub}>
          {t('auditEvents.export.inProgress.goToReportHub', 'Go to report hub')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
